import type { ReactNode } from 'react';

import { Spacing } from '@treneo/shared/themes';

import { styled } from '../styled';

import { Box } from './box';
import { Typography } from './typography';

const Container = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: nowrap;
  gap: ${Spacing.small};
  cursor: pointer;
  & > *:hover {
    text-shadow: 0 0 1px black;
  }
`;

const StyledTypography = styled(Typography)`
  text-wrap: nowrap;
`;

type Props = {
  icon: ReactNode;
  text: string;
  onClick: () => void;
};

export const ActionPosition = ({ icon, text, onClick }: Readonly<Props>) => (
  <Container onClick={onClick}>
    {icon}
    <StyledTypography>{text}</StyledTypography>
  </Container>
);
